import React from "react";
import CustomJS from "../../../components/BuilderComponents/CustomJS";
import { useFormContext } from "../../../context/FormContext";
import Input from "../../../components/FormComponents/Input";

// const parseFunctionString = (funcString) => {
//   const match = funcString.match(/\((.*?)\)/);
//   if (!match) return { argCount: 0, argNames: [] };
//   const argString = match[1];
//   const argNames = argString.split(",").map((arg) => arg.trim());
//   const argNameObje = argNames.reduce((acc, arg) => {
//     return {
//       ...acc,
//       [arg]: ""
//     };
//   }, {});
//   return argNameObje;
// };

const FormCustomFunctions = () => {
  const { formActvityData, setFormActivityData, selectedForm } = useFormContext();
  // const { axiosInstance, handleError } = useAxiosContext();
  // const [allFunctions, setAllFunctions] = useState({});
  // const [allFields, setAllFields] = useState({});
  // const [selectedFunction, setSelectedFunction] = useState("");
  // const [selectedParams, setSelectedParams] = useState({});

  // const fetchAllFunctions = async () => {
  //   try {
  //     const params = {};
  //     const { data } = await axiosInstance.get("/custom_function");
  //     const allfunc = data.reduce((acc, func) => {
  //       const arr = parseFunctionString(func.body);
  //       params[func.id] = arr;
  //       return {
  //         ...acc,
  //         [func.id]: func
  //       };
  //     }, []);
  //     setSelectedParams(params);
  //     const allFormField = getAllKeysOfCurrentFields();
  //     setAllFunctions(allfunc);
  //     setAllFields(allFormField);
  //   } catch (error) {
  //     handleError(error);
  //   }
  // };

  // const handleChangeFunction = (functionID) => {
  //   setSelectedFunction(functionID);
  //   if (functionID === "") return;
  //   const copyActivityData = JSON.parse(JSON.stringify(formActvityData));
  //   const functionData = allFunctions[functionID];
  //   const paramsObject = parseFunctionString(functionData.body);
  //   const objFunc = {
  //     function_id: functionID,
  //     params: paramsObject
  //   };
  //   copyActivityData.custom_functions = [...copyActivityData.custom_functions, objFunc];
  //   setFormActivityData(copyActivityData);
  // };

  const handleCustomJSChange = (data) => {
    const copyActivityData = JSON.parse(JSON.stringify(formActvityData));
    copyActivityData.custom_js = data;
    setFormActivityData(copyActivityData);
  };
  const handleChangeValidation = (e) => {
    setFormActivityData({ ...formActvityData, form_backend_validation: e.target.checked });
  };

  // const getAllKeysOfCurrentFields = () => {
  //   let fieldsArray = [];
  //   formSectionsData.current.forEach((sec) => {
  //     fieldsArray = [...fieldsArray, ...sec.fields];
  //   });
  //   const keysArray = {};
  //   fieldsArray.forEach((field) => {
  //     keysArray[field.id] = field;
  //     if (field.type === "container" || field.type === "recordset-list" || field.type === "recordset") {
  //       field.components.forEach((containerField) => {
  //         keysArray[containerField.id] = containerField;
  //       });
  //     }
  //   });
  //   return keysArray;
  // };

  // useEffect(() => {
  //   fetchAllFunctions();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  return (
    <div className="form_custom_function builder_form" style={{ height: "calc(100vh - 136px)" }}>
      {/* <div className="builder_form">
        <SingleSelectBox
          selectedData={selectedFunction}
          options={Object.values(allFunctions) || []}
          onChange={(obj) => handleChangeFunction(obj.id)}
          placeholder="Select Custom Function"
          label="Javascript Functions"
        />
      </div> */}
      {/* <div>
        {formActvityData.custom_functions?.map((func, i) => (
          <CustomFunctionsMappingCard
            key={func.function_id}
            index={i}
            currentFunc={func}
            allFunctions={allFunctions}
            allFields={allFields}
            selectedParams={selectedParams}
          />
        ))}
      </div> */}
      <Input
        type="checkbox"
        checked={formActvityData.form_backend_validation}
        label="Backend Validation"
        onChange={handleChangeValidation}
      />
      <div>
        <div style={{ minHeight: "50vh" }}>
          <CustomJS
            inputString={formActvityData.custom_js}
            handleChange={handleCustomJSChange}
            tableID={selectedForm.parentData.split("/")[0]}
            showFullScreenIcon={false}
          />
        </div>
      </div>
    </div>
  );
};

// const CustomFunctionsMappingCard = ({ currentFunc, allFunctions, allFields, index, selectedParams }) => {
//   const { formActvityData, setFormActivityData } = useFormContext();

//   const handleParamsFieldChange = (fieldID, param) => {
//     const copyActivityData = JSON.parse(JSON.stringify(formActvityData));
//     copyActivityData.custom_functions[index].params = {
//       ...copyActivityData.custom_functions[index].params,
//       [param]: fieldID
//     };
//     setFormActivityData(copyActivityData);
//   };

//   const deleteCustomFunction = () => {
//     const copyActivityData = JSON.parse(JSON.stringify(formActvityData));
//     copyActivityData.custom_functions.splice(index, 1);
//     setFormActivityData(copyActivityData);
//   };

//   if (!allFunctions[currentFunc.function_id]) {
//     return <div>Function not found</div>;
//   }
//   const newObject = modifiedObjectAsConfig(currentFunc.params, selectedParams[currentFunc.function_id]);
//   const arrayOfParams = Object.keys(newObject);
//   return (
//     <div className="d_flex" style={{ border: "1px solid gray", padding: "18px" }}>
//       <div>
//         <div>
//           <h3>{allFunctions[currentFunc.function_id].name}</h3>
//         </div>
//         {arrayOfParams.map((param, i) => {
//           if (param === "data") {
//             return null;
//           }
//           return (
//             <div key={param} style={{ padding: "6px 0", display: "flex" }}>
//               <div style={{ minWidth: "120px" }}>{param}</div>
//               <SingleSelectBox
//                 selectedData={currentFunc.params[param]}
//                 options={Object.values(allFields) || []}
//                 labelKey={["label"]}
//                 onChange={(obj) => handleParamsFieldChange(obj.id, param)}
//                 placeholder="Select "
//               />
//             </div>
//           );
//         })}
//       </div>
//       <div className="ml_auto">
//         <ButtonActionIcon type="delete" onClick={deleteCustomFunction} />
//       </div>
//     </div>
//   );
// };

export default FormCustomFunctions;
